import {
  DerivedEventTypeLegacy,
  FilterTypeLegacy,
  SimpleEventTypeLegacy,
  SubjectVariableTypeLegacy,
} from '@verantos-dev/types-cohorts';

export const getAvailableEventTypes = (
  eventEntityType:
    | SimpleEventTypeLegacy
    | DerivedEventTypeLegacy
    | SubjectVariableTypeLegacy
    | undefined
) => {
  switch (eventEntityType) {
    case SimpleEventTypeLegacy.CONDITION_OCCURRENCE:
      return [
        FilterTypeLegacy.CONCEPT,
        FilterTypeLegacy.RELATED_ENTITY,
        FilterTypeLegacy.UNIQUENESS,
      ];
    case SimpleEventTypeLegacy.VISIT_OCCURRENCE:
      return [
        FilterTypeLegacy.CONCEPT,
        FilterTypeLegacy.RELATED_ENTITY,
        FilterTypeLegacy.UNIQUENESS,
      ];
    case SimpleEventTypeLegacy.MEASUREMENT:
    case SimpleEventTypeLegacy.DRUG_EXPOSURE:
    case SimpleEventTypeLegacy.OBSERVATION:
    case SimpleEventTypeLegacy.PROCEDURE_OCCURRENCE:
      return [
        FilterTypeLegacy.CONCEPT,
        FilterTypeLegacy.NUMERIC,
        FilterTypeLegacy.RELATED_ENTITY,
        FilterTypeLegacy.UNIQUENESS,
      ];
    case DerivedEventTypeLegacy.INSTANCE:
      return [];
    case DerivedEventTypeLegacy.MERGED:
      return [FilterTypeLegacy.EVENT, FilterTypeLegacy.UNIQUENESS];
    case DerivedEventTypeLegacy.SEQUENCE:
      return [FilterTypeLegacy.EVENT, FilterTypeLegacy.TEMPORAL];
    case SubjectVariableTypeLegacy.COUNT:
      return [];
    case SubjectVariableTypeLegacy.DEMOGRAPHICS:
      return [FilterTypeLegacy.CONCEPT, FilterTypeLegacy.NUMERIC];
    default:
      return [];
  }
};
